/* eslint-disable*/
export default {
  grey: {
    400: 'rgba(160, 178, 204, 1)',
    600: 'rgba(84, 100, 122, 1)',
  },
  red: {
    50: 'rgba(254,247,247,1)',
    100: 'rgba(253,236,236,1)',
    200: 'rgba(252,216,216,1)',
    300: 'rgba(250,184,184,1)',
    400: 'rgba(248,150,150,1)',
    500: 'rgba(247,101,101,1)',
    600: 'rgba(231,37,37,1)',
    700: 'rgba(194,30,30,1)',
    800: 'rgba(168,24,24,1)',
    900: 'rgba(146,20,20,1)',
  },
  white: {
    100: 'rgba(255,255,255,1)',
    64: 'rgba(255,255,255,0.640)',
    80: 'rgba(255,255,255,0.800)',
    40: 'rgba(255,255,255,0.400)',
    25: 'rgba(255,255,255,0.240)',
    16: 'rgba(255,255,255,0.160)',
    8: 'rgba(255,255,255,0.080)',
    0: 'rgba(255,255,255,0.000)',
  },
  black: {
    100: 'rgba(0,0,0,1)',
    80: 'rgba(0,0,0,0.800)',
    64: 'rgba(0,0,0,0.640)',
    40: 'rgba(0,0,0,0.400)',
    24: 'rgba(0,0,0,0.240)',
    16: 'rgba(0,0,0,0.160)',
    8: 'rgba(0,0,0,0.080)',
  },
  secondary: {
    700: 'rgba(65, 70, 81, 1)',
    hover: 'rgba(37, 43, 55, 1)',
    border: 'rgba(233, 234, 235, 1)',
    background: 'rgba(250, 250, 250,1)',
  },
  primary: {
    900: 'rgba(24, 29, 39, 1)',
    hover: 'rgba(250, 250, 250, 1)',
    border: 'rgba(213, 215, 218, 1)',
    icon: 'rgba(153, 199, 255, 1)',
    'icon-hover': 'rgba(178, 213, 255, 1)',
    background: 'rgba(255, 255, 255, 1)',
  },
  quaternary: {
    25: 'rgba(253, 253, 253, 1)',
    50: 'rgba(250, 250, 250, 1)',
    100: 'rgba(245, 245, 245, 1)',
    200: 'rgba(233, 234, 235, 1)',
    300: 'rgba(213, 215, 218, 1)',
    400: 'rgba(164, 167, 174, 1)',
    500: 'rgba(113, 118, 128, 1)',
    600: 'rgba(83, 88, 98, 1)',
    700: 'rgba(65, 70, 81, 1)',
    800: 'rgba(37, 43, 55, 1)',
    900: 'rgba(24, 29, 39, 1)',
    950: 'rgba(10, 13, 18, 1)',
    hover: 'rgba(113, 118, 128, 1)',
  },
  tertiary: {
    600: 'rgba(83, 88, 98, 1)',
    hover: 'rgba(65, 70, 81, 1)',
    background: 'rgba(245, 245, 245,1)',
  },
  disabled: {
    background: 'rgba(245, 245, 245, 1)',
    subtle: 'rgba(233, 234, 235, 1)',
  },
  foreground: {
    disabled: 'rgba(164, 167, 174, 1)',
    'disabled-subtle': 'rgba(213, 215, 218, 1)',
  },
  other: {
    textPlaceholder: 'rgba(113, 118, 128, 1)',
  },
};
